import { render, staticRenderFns } from "./grip-info.vue?vue&type=template&id=6b4535ab&scoped=true&"
import script from "./grip-info.vue?vue&type=script&lang=js&"
export * from "./grip-info.vue?vue&type=script&lang=js&"
import style0 from "./grip-info.vue?vue&type=style&index=0&id=6b4535ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4535ab",
  null
  
)

export default component.exports